import V1 from '@/system-modules/groups/v1/SysGroupsV1'
import { ISysGroupsModule } from '@/contracts/system-modules/groups/ISysGroupsModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class SysGroupsProvider extends Provider<ISysGroupsModule> {
  realizations: Record<string, ISysGroupsModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysGroupsModule | null } = { module: null }

export function SysGroupsProviderModule(): ISysGroupsModule {
  const version = SystemModuleConfig.getGroupsVersion()

  if (!instance.module) {
    instance.module = new SysGroupsProvider().module(version)
  }

  return instance.module
}
